import eyeIcon from './../Assets/icons/eye 1.svg'
import editIcon from './../Assets/icons/Un-Checkbox.svg'

export const TABLE_HEADERS = [
    // "Sr No.",
    "Vendor Name",
    "Email Id",
    "Pan No",
    "Adhaar No.",
    "GST No.",
    "Address",

    "Status",
    "Action"
  ];
  
  export const TABLE_DATA = [
    { id: 1, vender_type_name: "Tier 1 Suppliers", vender_type_desc:"lorem ipsum",status: "Active", actions: "Edit/Delete" },
    { id: 2, vender_type_name: "Tier 2 Suppliers", vender_type_desc:"lorem ipsum",  status: "Inactive", actions: "Edit/Delete" },
    { id: 3, navender_type_nameme: "Component Suppliers", vender_type_desc:"lorem ipsum",  status: "Active", actions: "Edit/Delete" },
  ];
  
  export const keyMapping = {
    // "Sr No.": "Sr No.",
    "Vendor Name": "companyname",
   "Email Id":"email_id",
    "Pan No":"panno",
    "Adhaar No.":"aadharno",
    "GST No.":"gstno",
    "Address":"address", 
    "Status": "status",
    "Action": [
        { type: "edit", icon: editIcon, label: "Edit" },
        
      ]
  };